// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3JfX2","name":"Header_name__1gIxn","birthday":"Header_birthday__3Rtvy","skeleton":"Header_skeleton__2w1kS"};